<template>
  <div class="product-wrapper minh df fdc aic jcc f1 w100p" v-if="deleted">
    This project has been deleted
  </div>
  <div class="product-wrapper df fdc aifs f1 w100p posrel" v-else>


    <div class="add-coffee-popup" v-if="showAddNewCoffeePopup || customizingLink" @click="hidePopups()">

      <div v-if="customizingLink" class="add-coffee-popup-inner whole-page-box-global-2 whole-page-box-global-2-unset posrel df fdc" @click="stopProp($event)">

        <h2>Customize Your Session Link</h2>
        <div class="share-url share-url-v1 share-url-v3 dis" v-if="uniqueProductId" @click="stopProp($event)">
          <div class="df fd jcc aic posrel">
            <p class="header tac">Custom Link:</p>
            <a class="link link-bigger" :href="buildCustomLink()" target="_blank">{{buildCustomLink()}}</a>
            <p class="copied" :class="{'show-copied': showCopied}">
              copied
            </p>
            <a class="f1 df jcfe aic copy" @click="copyLink($event, buildCustomLink())">copy</a>
          </div>
        </div>

        <div class="custom-link-show-only df fdc">
          <h4 class="custom-h4">Show Only These Coffees</h4>
          <div class="df one-coffee-custom" v-for="(coffee, i) in coffees">
            <div class="check-fulfillment">
              <input v-model="showOnly[i]"
              type="checkbox"
              class="check-fulfillment-box"
              name=""
              :id="'code' + i">
              <label :for="'code' + i"></label>
            </div>
            <p class="custom-link-coffee-name">{{coffee.name}}</p>
          </div>
        </div>
        <h4 class="custom-h4">Make Embeddable</h4>
        <div class="df">
          <div class="check-fulfillment">
            <input v-model="embedCode"
            type="checkbox"
            class="check-fulfillment-box"
            name=""
            id="embedCode">
            <label for="embedCode"></label>
          </div>
          <p class="_s1 custom-link-coffee-name">On</p>
        </div>
        <div class="df aic" v-bind:class="{
          'disable-custom': !embedCode
        }">
          <div class="check-fulfillment">
            <input class="embed-input" v-model="embedCodeHeight" type="number"/>
          </div>
          <p class="_s1 custom-embed-label">Height (pixels)</p>
        </div>
        <div class="df aic" v-bind:class="{
          'disable-custom': !embedCode
        }">
          <div class="check-fulfillment">
            <input class="embed-input" v-model="embedCodeWidth" type="number"/>
          </div>
          <p class="_s1 custom-embed-label">Width (pixels)</p>
        </div>

        <!-- <a class="button-1" @click="()=>{}">Copy</a> -->
        <!-- <p class="tac curp" @click="hidePopups()">Cancel</p> -->


        <div class="x-close curp" @click="hidePopups()"><i class="fal fa-times"></i></div>
      </div>
      <div v-else-if="showAddNewCoffeePopup" class="add-coffee-popup-inner whole-page-box-global-2 whole-page-box-global-2-unset posrel df fdc" @click="stopProp($event)">
        <h3>Add a coffee to your cupping session</h3>

        <div class="product-detail product-detail-add-new df" @click="selectCoffeeType('Existing')" v-bind:class="{
          'not-selected-coffee-type': addNewCoffeeType !== 'Existing',
          'add-coffee-popup-inner-selected': addNewCoffeeType == 'Existing'
        }">
          <div class="check-fulfillment">
            <input v-model="addNewCoffeeType" type="radio" id="one" value="Existing" class="check-fulfillment-box" name="">
          </div>
          <div class="check-detail f1">
            <h4 class="curp">Select Existing Coffee <span class="validation-error">{{addExistingCoffeeValidationError}}</span></h4>
            <div class="existing-coffee-wrapper df fdc w100p" v-if="Object.keys($store.getters['AUTH.myCoffees']).length > 0">
              <select class="mb1" v-model="selectedCoffee">
                <option :value="i" v-for="(coffee, i) in $store.getters['AUTH.myCoffees']">{{coffee.name}}</option>
              </select>
              <div class="more-options df w100p aic" @click="setShowMoreExistingCoffeeOptions(!showMoreExistingCoffeeOptions)">
              <img v-if="showMoreExistingCoffeeOptions" src="../../static/images/icon-less-options.svg" class="more-less-options"></i>
              <img v-else src="../../static/images/icon-more-options.svg" class="more-less-options">
                <p>{{showMoreExistingCoffeeOptions ? 'less' : 'more'}} options</p>
              </div>
              <div class="more-options-open" v-if="showMoreExistingCoffeeOptions">
                <h4>Blind Tasting Identifier</h4>
                <input v-model="addExistingCoffeeBlindTastingIdentifier" placeholder="#1, A, etc." type="" name="">
              </div>
            </div>
            <p v-else>You have no coffees</p>
          </div>
        </div>
        <!-- <br/> -->
        <div class="product-detail product-detail-add-new df" @click="selectCoffeeType('New')" v-bind:class="{
          'not-selected-coffee-type': addNewCoffeeType !== 'New',
          'add-coffee-popup-inner-selected': addNewCoffeeType == 'New'
        }">
          <div class="check-fulfillment">
            <input v-model="addNewCoffeeType" type="radio" id="two" value="New" class="check-fulfillment-box" name="">
          </div>
          <div class="check-detail f1">
            <h4 class="curp">Add New Coffee <span class="validation-error">{{addNewCoffeeValidationError}}</span></h4>
            <input v-model="addNewCoffeeInput" placeholder="Coffee Name" type="" name="">
            <div class="more-options df w100p aic" @click="setShowMoreNewCoffeeOptions(!showMoreNewCoffeeOptions)">
              <img v-if="showMoreNewCoffeeOptions" src="../../static/images/icon-less-options.svg" class="more-less-options"></i>
              <img v-else src="../../static/images/icon-more-options.svg" class="more-less-options">
              <p>{{showMoreNewCoffeeOptions ? 'less' : 'more'}} options</p>
            </div>

            <div class="more-options-open" v-if="showMoreNewCoffeeOptions">
              <h4>Blind Tasting Identifier</h4>
              <input v-model="addNewCoffeeBlindTastingIdentifier" placeholder="#1, A, etc." type="" name="">
              <br/>
              <h4>Buy Now Link</h4>
              <input v-model="addNewCoffeeBuyNowLink" placeholder="http://" type="" name="">
              <br/>
              <!-- <h4>Product Image</h4> -->
                <h4>Thumbnail</h4>
                <div v-if="productImageUrl" class="dropzone-wrapper image-dropzone-wrapper posrel df fdc aic jcc add-new-image-dropzone-wrapper">
                  <img class="image-uploaded" :src="addNewCoffeeImageUrl">
                  <a class="w100p tac image-uploaded-under" @click="removeProductImage()">Remove Image</a>
                </div>
                <div v-else class="dropzone-wrapper image-dropzone-wrapper posrel add-new-image-dropzone-wrapper">
                  
                  <vue-dropzone ref="myVueDropzone" 
                          id="dropzone-a"
                          class="image-upload"
                          @vdropzone-file-added="uploadedProductImage"
                          :options="dropzoneOptions">
                  </vue-dropzone>
                  <div class="dropzone-overlay df fdc">
                    <p>Drag Image Here</p>
                    <p>or</p>
                    <a class="button-3 df aic jcc">Upload Image</a>
                  </div>
                </div>
              <!-- <h4>Blind Tasting Identifier (ie, #1, A, etc)</h4> -->
              <!-- <input v-model="addNewCoffeeInput" placeholder="New Coffee" type="" name=""> -->
            </div>

          </div>
        </div>
        <div class="df aic">
          <a class="button-1" @click="addCoffeeToTastingSession()">Add Coffee</a>
          <p class="cancel-add tac curp" @click="hidePopups()">Cancel</p>
        </div>


        <div class="x-close curp" @click="hidePopups()"><i class="fal fa-times"></i></div>
      </div>
    </div>

    <!-- <div class="top-bar-global w100p df jcsb aic">
      <div class="breadcrumb df">
        <h2 class="breadcrumb-other" @click="goTo('/me')">Home</h2>
        <h2 class="breadcrumb-separator">-</h2>
        <h2 class="breadcrumb-other" @click="goTo('/sessions')">Cupping</h2>
        <h2 class="breadcrumb-separator">-</h2>
        <h2>{{newOrEdit()}}</h2>
      </div>
      
    </div> -->

    

    <div class="whole-page-box-global-2 whole-page-box-global-2-unset w100p df fdc aifs">
          <!-- <h3>{{productTypeDisplay()}} Info</h3> -->

      <span class="back-arrow-main posrel" @click="goTo('/sessions')">
          <img src="../../static/images/back-arrow-main.svg" alt="">
          <p>Back</p>
          <div class="share-url share-url-v1" v-if="uniqueProductId" @click="stopProp($event)">
            <div class="df fd jcc aic posrel">
              <p class="header">Your Session Link:</p>
              <a class="link link-bigger" :href="'https://cup-wise.com/live/' + uniqueProductId" target="_blank">https://cup-wise.com/live/{{uniqueProductId}}</a>
              <p class="copied" :class="{'show-copied': showCopied}">
                copied
              </p>
              <a class="f1 df jcfe aic copy" @click="copyLink($event, 'https://cup-wise.com/live/' + uniqueProductId)">copy</a>
            </div>
          </div>
      </span>
      <div class="share-url share-url-v2" v-if="uniqueProductId">
        <div class="df fd jcc aic posrel">
          <p class="header">Your Session Link:</p>
          <a class="link link-bigger" :href="'https://cup-wise.com/live/' + uniqueProductId" target="_blank">https://cup-wise.com/live/{{uniqueProductId}}</a>
          <p class="copied" :class="{'show-copied': showCopied}">
            copied
          </p>
          <a class="f1 df jcfe aic copy" @click="copyLink($event, 'https://cup-wise.com/live/' + uniqueProductId)">copy</a>
          <a class="f1 df jcfe aic copy" @click="customizeLink($event, true)">customize</a>
        </div>
      </div>
      <span v-if="uniqueProductId && passwordScoring" class="df w100p fww special-link">
        <p>Private scoring link: </p>
        <a class="link link-bigger" v-if="passwordScoring" :href="'https://cup-wise.com/live/' + uniqueProductId + '?spl=' + spl" target="_blank">https://cup-wise.com/live/{{uniqueProductId}}?spl={{spl}}</a>
      </span>
      <hr class="line-x" v-if="uniqueProductId && passwordScoring">
      <h3 class="df posrel">Template Details</h3>
      <div class="digital-download-details df fdrr jcfe aifs f1 _x">
        <div v-if="productImageUrl" class="dropzone-wrapper image-dropzone-wrapper posrel df fdc aic jcc">
          <img class="image-uploaded" :src="productImageUrl">
          <a class="w100p tac image-uploaded-under" @click="removeProductImage()">Remove Image</a>
        </div>
        <div v-else class="dropzone-wrapper dropzone-wrapper-a image-dropzone-wrapper posrel">
          
          <h4 class="h4">Thumbnail</h4>
          <vue-dropzone ref="myVueDropzone" 
                  id="dropzone-a"
                  class="image-upload"
                  @vdropzone-file-added="uploadedProductImage"
                  :options="dropzoneOptions">
          </vue-dropzone>
          <div class="dropzone-overlay df fdc">
            <p>Drag Image Here</p>
            <p>or</p>
            <a class="button-3 df aic jcc">Upload Image</a>
          </div>
        </div>
        <div class="product-basics f1 df fdc">
          <div class="df w100p jcsb product-detail-outer">
            <div class="product-detail">
              <h4>Name</h4>
              <input placeholder="Name Your Session" v-model="heading" type="" name="">
            </div>
          </div>
          <div class="df w100p jcsb product-detail-outer">
            <div class="product-detail">
              <h4>Steps</h4>
              <div class="template-steps df fdc">
                <div class="template-step">
                  Step
                </div>
              </div>
              <!-- <input placeholder="Name Your Session" v-model="heading" type="" name=""> -->
            </div>
          </div>
          <br/>
          <br/>
          <br/>
          <br/>
          <br/>
          <br/>
          <br/>
          <br/>
          <br/>
          --------
          <br/>
          <br/>
          <br/>
          <br/>
          <br/>
          <br/>
          <br/>
          <br/>
          <br/>
          <br/>
          <br/>
          <br/>
<!--           <div class="product-detail product-detail-desctiption f1 df fdc">
            <h4>Description</h4>
            <wysiwyg v-model="description" />
            <textarea placeholder="Describe your session" v-model="description" class="f1"></textarea>
          </div> -->
          <div class="df w100p jcsb product-detail-outer">
            <div class="product-detail">
              <h4>Start Date</h4>
              <date-picker 
                @change="test"
                v-model="startsAt"
                :show-second="false"
                :confirm="true"
                :use12h="true"
                :minute-step="5"
                :time-title-format="'hh:mma'"
                :title-format="'MMMM YYYY'"
                :show-time-header="true"
                :header="'Test'"
                type="datetime">
              </date-picker>
              <!-- <input placeholder="Name Your Session" v-model="heading" type="" name=""> -->
            </div>
          </div>
          <div class="product-detail product-detail-with-check df">
            <div class="check-detail f1">
              <div class="df">
                <div class="check-fulfillment">
                  <input v-model="enableVideo"
                  type="checkbox"
                  class="check-fulfillment-box"
                  name=""
                  id="enableVideo">
                  <label for="enableVideo"></label>
                </div>
                <h4 class="_s1">Add Live/Recorded Video</h4>
              </div>
              <input placeholder="YouTube Video ID" v-model="youtubeVideoUrl" type="" name="" class="_s2">
              <p class="sub-line _s3">Add your YouTube video link to show a live stream or recorded video along with your tasting session.</p>
            </div>
          </div>
        </div>
      </div>
      <div class="digital-download-details df fdc f1">
<!--         <div v-if="productImageUrl" class="dropzone-wrapper image-dropzone-wrapper posrel df fdc aic jcc">
        </div> -->
<!--         <div v-else class="dropzone-wrapper image-dropzone-wrapper posrel">
          <vue-dropzone ref="myVueDropzone" 
                  id="dropzone-a"
                  class="image-upload o00"
                  @vdropzone-file-added="uploadedProductImage"
                  :options="dropzoneOptions">
          </vue-dropzone>
          <div class="dropzone-overlay df fdc o00">
            <p>Drag Image Here</p>
            <p>or</p>
            <a class="button-b df aic jcc">Upload File</a>
          </div>
        </div> -->
        <div class="df _s8">
          <div class="product-basics f1 df fdc">
            <div class="df fdc">
              <h3 class="_s4">Session Options</h3>
              <p class="tag">(options cannot be changed after cupping has started)</p>
            </div>

            <div class="selected-coffees" v-bind:class="{
            'o05': uniqueProductId
          }">
              <h4 class="h4">Select coffees for cupping</h4>
              <div class="coffees-selected df fww">
                <div class="df one-selected-coffee add-new-coffee" @click="showAddNewCoffee()">
                  <span class="df fdc jcc aic w100p">
                    <p class="w100p tac name">Add Coffee</p>
                    <img src="../../static/images/new-circle-plus.svg" class="plus">
                    <!-- <p class="w100p tac plus">+</p> -->
                  </span>
                </div>
                <div class="df one-selected-coffee" v-for="(coffee, i) in coffees">
                  <span class="df fdc jcc aic">
                    <p class="tac">{{coffee.name}}</p>
                    <p v-if="coffee.blindTastingId">{{coffee.blindTastingId}}</p>
                  </span>
                  <img class="remove-selected-coffee" src="../../static/images/black-x.svg" @click="removeCoffeeFromTastingSession(i)">
                </div>
              </div>
            </div>

            <div class="df w100p jcsb product-detail-outer" v-bind:class="{
            'o05': uniqueProductId
          }">
              <div class="product-detail">
                <h4 class="_s5">Select Template</h4>
                <select v-model="selectedTemplate">
                  <option value="" selected disabled hidden>Select</option>
                  <option :value="i" v-for="(template, i) in templates">{{template.name}}</option>
                </select>
              </div>
            </div>
          </div>




          <div class="product-basics product-detail-list f1 df fdc _s6">
            <h3 class="mtx _s7" v-bind:class="{
              'o05': uniqueProductId
            }">&nbsp;</h3>

            <div class="df fdc bl">

              <!-- <div class="product-detail df" v-bind:class="{
                'o05': uniqueProductId
              }">
                <div class="check-fulfillment">
                  <input v-model="scoringStarted" id="scoringStarted" type="checkbox" class="check-fulfillment-box" name="">
                  <label for="scoringStarted"></label>
                </div>
                <div class="check-detail f1">
                  <h4>Automatically start session</h4>
                  <p class="sub-line">The session will start automatically after it is created.</p>
                </div>
              </div>

              <div class="product-detail df" v-bind:class="{
                'o05': uniqueProductId
              }">
                <div class="check-fulfillment">
                  <input v-model="scoringLocked" id="scoringLocked" type="checkbox" class="check-fulfillment-box" name="">
                  <label for="scoringLocked"></label>
                </div>
                <div class="check-detail f1">
                  <h4>Start with scoring locked</h4>
                  <p class="sub-line">Start the session with scoring locked.</p>
                </div>
              </div> -->

              <div class="product-detail df" v-bind:class="{
                'o05': uniqueProductId
              }">
                <div class="check-fulfillment">
                  <input @input="passwordOn" :checked="passwordScoring ? true : false" id="passwordScoring" type="checkbox" class="check-fulfillment-box" name="">
                  <label for="passwordScoring"></label>
                </div>
                <div class="check-detail f1">
                  <h4>Private Scoring</h4>
                  <p class="sub-line">Users can only add scores with a special link</p>
                  <!-- <input placeholder="" v-if="!passwordScoring" value="" placeholder="Scoring password" type="" name="" class="_s2" > -->
                </div>
              </div>
              <div class="product-detail df" v-bind:class="{
                'o05': uniqueProductId
              }">
                <div class="check-fulfillment">
                  <input v-model="enableChat" id="enableChat" type="checkbox" class="check-fulfillment-box" name="">
                  <label for="enableChat"></label>
                </div>
                <div class="check-detail f1">
                  <h4>Enable chat</h4>
                  <p class="sub-line">Allow users to comment and discuss the the tasting session.</p>
                </div>
              </div>
              <div class="product-detail df" v-bind:class="{
                'o05': uniqueProductId
              }">
                <div class="check-fulfillment">
                  <input v-model="enableBlindCupping" type="checkbox" id="enableBlindCupping" class="check-fulfillment-box" name="">
                  <label for="enableBlindCupping"></label>
                </div>
                <div class="check-detail f1">
                  <h4>Enable blind cupping</h4>
                  <p class="sub-line">Viewers will only be shown the coffee identifier until the host reveals the name of the coffee.</p>
                </div>
              </div>
              <div class="product-detail df" v-bind:class="{
                'o05': uniqueProductId
              }">
                <div class="check-fulfillment">
                  <input v-model="colorMode" type="checkbox" id="colorMode" class="check-fulfillment-box" name="">
                  <label for="colorMode"></label>
                </div>
                <div class="check-detail f1">
                  <h4>Color mode</h4>
                  <p class="sub-line">Add colors to coffee titles.</p>
    <!--               <div class="color-options">
                    <div class="one-color-option color-1 df fdc">
                      <div class="color-row df">
                        <div class="one-color">
                            
                        </div>
                        <div class="one-color">
                            
                        </div>
                      </div>
                      <div class="color-row df">
                        <div class="one-color">
                          
                        </div>
                        <div class="one-color">
                          
                        </div>
                      </div>
                    </div>
                  </div> -->
                </div>
              </div>

              <div class="product-detail df" v-bind:class="{
                'o05': uniqueProductId || true
              }">
                <div class="check-fulfillment">
                  <input v-model="allowAnonymousViewing" id="allowAnonymousViewing" type="checkbox" class="check-fulfillment-box" name="">
                  <label for="allowAnonymousViewing"></label>
                </div>
                <div class="check-detail f1">
                  <h4>Allow anonymous viewers</h4>
                  <p class="sub-line">Allow users to watch the cupping session anonymously without signing in.</p>
                </div>
              </div>
              <div class="product-detail df" v-bind:class="{
                'o05': uniqueProductId || true
              }">
                <div class="check-fulfillment">
                  <input v-model="allowAnonymousVoting" id="allowAnonymousVoting" type="checkbox" class="check-fulfillment-box" name="">
                  <label for="allowAnonymousVoting"></label>
                </div>
                <div class="check-detail f1">
                  <h4>Allow anonymous scoring</h4>
                  <p class="sub-line">Allow users to vote anonymously without signing in.</p>
                </div>
              </div>
            </div>

          </div>
        </div>

          <div class="share-url share-url2" v-if="uniqueProductId">
            <div class="df fd jcc aic posrel">
              <p class="header">Your Session Link:</p>
              <a class="link link-bigger" :href="'https://cup-wise.com/live/' + uniqueProductId" target="_blank">https://cup-wise.com/live/{{uniqueProductId}}</a>
              <p class="copied" :class="{'show-copied': showCopied}">
                copied
              </p>
              <a class="f1 df jcfe aic copy" @click="copyLink($event, 'https://cup-wise.com/live/' + uniqueProductId)">copy</a>
              <a class="f1 df jcfe aic copy" @click="customizeLink($event, true)">customize</a>
            </div>
          </div>
          <span v-if="uniqueProductId && passwordScoring" class="df w100p fww special-link">
            <p>Private scoring link: </p>
            <a class="link link-bigger" v-if="passwordScoring" :href="'https://cup-wise.com/live/' + uniqueProductId + '?spl=' + spl" target="_blank">https://cup-wise.com/live/{{uniqueProductId}}?spl={{spl}}</a>
          </span>














          <div class="product-detail df" v-if="saveLiveTastingError">
            <p class="save-session-error">{{saveLiveTastingError}}</p>
          </div>
          <div class="product-detail df">
            <!-- <button>Start</button> -->
            <h4 @click="deactivateProduct()" v-if="public" class="button-0 just-save">Deactivate</h4> 
            <h4 @click="saveProduct()" v-if="public" class="button-1">Save</h4> 
            <h4 @click="saveProduct()" v-if="!public" class="button-2 just-save just-save-2">Save</h4> 
            <h4 @click="saveProduct(true)" v-if="!public" class="button-1">Start Session</h4> 
          </div>



        </div>
      </div>
    </div>

  </div>
</template>

<script>

import router from '@/router'
import common from '@/util/common'
import products from '@/util/products'
import tasting_templates from '@/util/tasting_templates'
import LandingProduct from '@/components/LandingProduct'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import ClickOutside from 'vue-click-outside'
import { firebase } from '@/util/firebase'
import { firebaseInstance } from '@/util/firebase'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

// LIVE CUPPING HOST PAGE
//                          EDIT  LIVE
// select coffees           yes
// select template          yes
// edit video link          yes   yes    
// set status published     yes   yes
// set session name         yes   yes     
// start/stop session             yes
// answer question                yes
// remove question                yes
// ban user                       yes
// allow anonymous scores   yes
// allow anonymous viewers  yes


export default {
  name: 'AddTemplate',
  data () {
    return {
      showOnly: [],
      embedCode: false,
      embedCodeHeight: 420,
      embedCodeWidth: 600,
      showCopied: false,
      showMoreNewCoffeeOptions: false, 
      showMoreExistingCoffeeOptions: false, 
      selectedTemplate: '',
      youtubeVideoUrl: '',
      enableChat: false,
      passwordScoring: false,
      spl: false,
      enableVideo: false,
      allowAnonymousViewing: true,
      allowAnonymousVoting: true,
      templates: tasting_templates,

      enableBlindCupping: false,
      allowViewerAverageControl: false,
      colorMode: false,
      colorModeOption: 1,

      saveLiveTastingError: '',
      coffees: [],
      addNewCoffeeBlindTastingIdentifier: '',
      addExistingCoffeeBlindTastingIdentifier: '',
      addNewCoffeeImageUrl: '',
      addNewCoffeeBuyNowLink: '',
      showAddNewCoffeePopup: false,
      selectedCoffee: '',
      addNewCoffeeType: 'Existing',
      addNewCoffeeInput: '',
      addNewCoffeeValidationError : '',
      addExistingCoffeeValidationError : '',
 
      dropzoneOptions: {
          autoProcessQueue: false,
          url: 'https://',
          thumbnailWidth: 150,
          maxFilesize: 1,
          dictDefaultMessage: ``
          // headers: { "My-Awesome-Header": "header value" },
          // dictDefaultMessage: 'Check',
          // previewTemplate: document.querySelector('#template-container').innerHTML
      },
      dropzoneOptions2: {
          autoProcessQueue: false,
          url: 'https://',
          thumbnailWidth: 150,
          maxFilesize: 20,
          // headers: { "My-Awesome-Header": "header value" },
          // dictDefaultMessage: 'Check',
          // previewTemplate: document.querySelector('#template-container').innerHTML
          dictDefaultMessage: ``
      },
      loading: false,
      productImageUrl: '',
      productDeliveryFile: '',
      heading: 'My New Tasting',
      price: 5.00,
      description: 'About my awesome product',
      secondaryHeading: 'Get it now!',
      redirectURL: '',
      callToActionText: 'Purchase',
      productType: '',
      addFile: true,
      addURL: false,
      created: '',
      modified: '',
      ownerId: null,
      productId: null,
      startsAt: '',
      uniqueProductId: null,
      public: false,
      deleted: false,
      customizingLink: false
    }
  },
  props: ['feel'],
  components: {
    LandingProduct,
    vueDropzone: vue2Dropzone,
    DatePicker
  },
  methods: {
    passwordOn (e) {
      let password = Math.floor(Math.random() * 100000000000)
      if (!this.passwordScoring) {
        this.passwordScoring = true
      } else {
        this.passwordScoring = false
      }
      if (!this.spl) {
        this.spl = password
        this.passwordScoring = true
      }
    },
    test (e) {
      console.log('TEST', e)
    },
    buildCustomLink () {
      let url = 'https://cup-wise.com/live/'
      let add = ''
      for (let one in this.showOnly) {
        if (this.showOnly[one]) {
          add = add + (parseInt(one) + 1) + ','
        }
      }
      if (add.length > 0) {
        add = add.substring(0, add.length-1)
      }
      let id = this.uniqueProductId

      url = url + id + '/' + add

      if (this.embedCode) {
        url = `<iframe src="` + url + `" title="Score this coffee with Cupwise" height="` + this.embedCodeHeight + `" width="` + this.embedCodeWidth + `"></iframe>`
      }

      return url
    },
    customizeLink (event, customizingLink) {
      event.stopPropagation()
      this.customizingLink = customizingLink
    },
    stopProp (e) {
      e.stopPropagation()
    },
    flashCopied () {
      this.showCopied = true
      setTimeout(() => {
        this.showCopied = false
      }, 1000)
    },
    copyLink (e, link) {
      e.stopPropagation()
      navigator.clipboard.writeText(link);
      this.flashCopied()
    },
    removeCoffeeFromTastingSession (index) {
      let coffees = this.coffees
      coffees.splice(index, 1)
      this.coffees = coffees
    },
    clearAddCoffeeForm () {
      this.addNewCoffeeBlindTastingIdentifier = ''
      this.addExistingCoffeeBlindTastingIdentifier = ''
      this.addNewCoffeeImageUrl = ''
      this.addNewCoffeeBuyNowLink = ''
      this.selectedCoffee = ''
      this.addNewCoffeeType = 'Existing'
      this.addNewCoffeeInput = ''
      this.showMoreNewCoffeeOptions = ''
      this.showMoreExistingCoffeeOptions = ''
      this.addNewCoffeeValidationError = ''
      this.addExistingCoffeeValidationError = ''
      this.enableBlindCupping = false
      this.allowViewerAverageControl = false
      this.colorMode = false
      this.colorModeOption = 0
    },
    addCoffeeToTastingSession () {
      let coffees = this.coffees
      let coffeeObject = {}

      // check new of existing selected
      
      let run = async () => {
        if (this.addNewCoffeeType == 'New') {
          coffeeObject = {
            blindTastingId: this.addNewCoffeeBlindTastingIdentifier,
            name: this.addNewCoffeeInput,
            imageUrl: this.addNewCoffeeImageUrl,
            buyNowLink: this.addNewCoffeeBuyNowLink,
            // bag: 'blue' // ?
          }
          // validate
          console.log('coffeeObject', coffeeObject)
          if (coffeeObject.name) {
            // create coffee

            var addedCoffee = firebase.functions().httpsCallable('addNewCoffee')
            let p = await addedCoffee(coffeeObject)

            coffees.push(coffeeObject)
            this.coffees = coffees

            this.clearAddCoffeeForm()

            this.showAddNewCoffeePopup = false
            document.body.className = ''
          } else {
            this.addNewCoffeeValidationError = '* Please give the coffee a name'
            console.log('addNewCoffeeValidationError', this.addNewCoffeeValidationError)
          }
        } else if (this.addNewCoffeeType == 'Existing') {
          console.log('existing coffee', this.selectedCoffee)

          if (this.selectedCoffee) {
            let coffeeObject = this.$store.getters['AUTH.myCoffees'][this.selectedCoffee]
            coffeeObject.blindTastingId = this.addExistingCoffeeBlindTastingIdentifier
            // create coffee
            coffees.push(coffeeObject)
            this.coffees = coffees

            this.clearAddCoffeeForm()

            this.showAddNewCoffeePopup = false
            document.body.className = ''
            // flash new coffee ?
          } else {
            this.addExistingCoffeeValidationError = '*Please select a coffee'
            console.log('addExistingCoffeeValidationError', this.addExistingCoffeeValidationError)
          }
        }

      }
      run()


      console.log('abc', this.coffees)

    },
    setShowMoreNewCoffeeOptions (v) {
      this.showMoreNewCoffeeOptions = v
    },
    setShowMoreExistingCoffeeOptions (v) {
      this.showMoreExistingCoffeeOptions = v
    },
    stopProp (e) {
      e.stopPropagation()
    },
    showAddNewCoffee () {
      this.showAddNewCoffeePopup = true
      document.body.className = 'popup-shown'
    },
    hidePopups () {
      // if (this.showAddNewCoffeePopup) {
      this.showAddNewCoffeePopup = false
      this.customizingLink = false
      document.body.className = ''
      this.clearAddCoffeeForm()
      // }
    },
    selectCoffeeType (type) {
      console.log('type', type)
      if (type == 'Existing') {
        this.showMoreNewCoffeeOptions = false
      } else if (type == 'New') {
        this.showMoreExistingCoffeeOptions = false
      }
      this.addNewCoffeeType = type
    },
    goTo (path, event) {
      event && event.stopPropagation()
      router.push(path)
    },
    changePrice (e) {
      let price = e.target.value
      console.log('price', price)
      this.price = price * 100
    },
    newOrEdit () {
      if (this.uniqueProductId) {
        return 'Edit '
      }
      return 'New '
    },
    productTypeDisplay () {
      let type = this.productType
      // console.log('type', type)
      if (type == 'live-session') {
        return 'Cupping'
      } else if (type == 'digital-service') {
        return 'Service'
      } else if (type == 'calendar-event') {
        return 'Calendar Invite'
      }
      return ''
    },
    deactivateProduct () {
      this.$store.dispatch('AUTH.deactivateProduct', {uniqueProductId: this.uniqueProductId}).then((res) => {
        console.log('PRODUCT deactivated', res)
        if (res == 'ok') {
          this.public = false
        }
      })
    },
    deleteProduct () {
      let productObject = {
        uniqueProductId: this.uniqueProductId,
        productId: this.productId,
      }
      this.$store.dispatch('AUTH.deleteProduct', productObject).then((res) => {
        console.log('Product archived', res)
        this.deleted = true
      })
    },
    saveProduct (activate) {
      let productObject = {
        heading: this.heading,
        description: this.description,
        productImageUrl: this.productImageUrl,
        youtubeVideoUrl: this.youtubeVideoUrl,
        enableChat: this.enableChat,
        enableVideo: this.enableVideo,
        passwordScoring: this.passwordScoring,
        spl: this.spl,
        uniqueProductId: this.uniqueProductId,
        scoringLocked: true,
        scoringStarted: false,
        productId: this.productId,
        options: {
          coffees: this.coffees,
          selectedTemplate: this.selectedTemplate,
          selectedTemplateData: this.templates[this.selectedTemplate],
          enableBlindCupping: this.enableBlindCupping,
          allowViewerAverageControl: this.allowViewerAverageControl, 
          allowAnonymousVoting: this.allowAnonymousVoting,
          allowAnonymousViewing: this.allowAnonymousViewing,
          colorMode: this.colorMode,
          colorModeOption: this.colorModeOption,
        },
      }
        console.log('saveProduct', productObject)
      // validation
      if (!productObject.heading) {
        this.saveLiveTastingError = '* Please give the session a name.'
      } else if (productObject.options.coffees.length == 0) {
        this.saveLiveTastingError = '* Please select coffees for tasting.'
      } else if (!productObject.options.selectedTemplate) {
        this.saveLiveTastingError = '* Please select a tasting template.'
      } else {
        this.saveLiveTastingError = false
        if (activate) {
          productObject.public = true
        }
        console.log('saveProduct', productObject)
        console.log('2', this.templates)
        this.$store.dispatch('AUTH.saveLiveTastingProduct', productObject).then((res) => {
          console.log('*!')
          let product = res
          for (let i in product) {
            this[i] = product[i]
          }

        })
      }

    },
    removeProductImage () {
      this.productImageUrl = ''
    },
    removeProductDeliveryFile () {
      this.productDeliveryFile = ''
    },
    uploadedProductImage (file) {
      let item = {
        productId: this.productId,
        file
      }
      this.$store.dispatch('AUTH.uploadProductImage', item).then((res) => {
        this.productImageUrl = res.url
      })
    },
    uploadedProductDeliveryFile (file) {
      let item = {
        productId: this.productId,
        file
      }
      this.$store.dispatch('AUTH.uploadProductDeliveryFile', item).then((res) => {
        this.productDeliveryFile = res
      })
    },
    generateNewInternalProductId () {
    },
    loadDefaultProduct () {
      let randomNumber = Math.floor(Math.random() * 100000000000)
      let now = (new Date()).getTime()
      let route = this.$route
      let type = route.params.type

      let defaultProduct = {
        myTimezone: '(GMT-05:00) Eastern Time (US & Canada)',
        appointmentLength: '15 minutes',
        productImageUrl: '',
        productDeliveryFile: '',
        heading: 'My New Tasting Template',
        price: 5.00,
        description: '',
        secondaryHeading: 'Get it now!',
        redirectURL: '',
        callToActionText: 'Purchase',
        productType: type,
        addFile: true,
        passwordScoring: false,
        spl: false,
        addURL: false,


        created: now,
        modified: '',
        productId: randomNumber,
        uniqueProductId: null
      }
      for (let i in defaultProduct) {
        this[i] = defaultProduct[i]
      }

    },
    getProductData () {
      let route = this.$route
      let productId = route.params.id
      if (productId) {
        this.$store.dispatch('AUTH.getLiveCuppingProductDetails', productId).then((product) => {
          for (let i in product) {
            console.log('product', product[i])
            this[i] = product[i]
          }
          console.log('product1', product)
          let coffees = product.options.coffees
          this.coffees = coffees
          for (let one in coffees) {
            this.showOnly[one] = true
          }
          this.colorMode = product.options.colorMode
          this.startsAt = product.startsAt ? new Date(product.startsAt) : ''
          this.colorModeOptions = product.options.colorModeOptions
          this.coffees = coffees
          this.selectedTemplate = product.options.selectedTemplate
          this.enableBlindCupping = product.options.enableBlindCupping
          this.allowViewerAverageControl = product.options.allowViewerAverageControl
          this.allowAnonymousViewing = product.options.allowAnonymousViewing
          this.allowAnonymousVoting = product.options.allowAnonymousVoting
        })
      }
    },
    setupProduct () {
      this.loadDefaultProduct()
      this.getProductData()
    }
  },
  computed: {
  },
  watch: {
  '$route.params': {
      handler: (params) => {
        let id = params.id
         if (id) {
          // this.getLiveCuppingProductDetails()
         } else {
          // this.loadDefaultProduct()
         }
      },
      // deep: true,
      immediate: true
    }
  },
  created () {
    this.setupProduct()

    console.log('let route = this.$route', this.$route.params.type)
    this.productType = this.$route.params.type
  },
  directives: {
    ClickOutside
  }
}
</script>

<style scoped lang="scss">
  @import "../styles/settings.scss";

  ._position1 {
    margin-top: 8px;
  }

  ._s1 {
    margin-bottom: 13px !important;
  }

  ._s2 {
    margin-bottom: 15px !important;
  }

  ._s3 {
    margin-bottom: 47px !important;
  }

  ._s4 {
    margin-bottom: 1px !important;
  }

  ._s5 {
    margin-bottom: 16px !important;
  }

  ._s6 {
    & > div {
      padding-left: 25px !important;
    }
  }
  ._s7 {
    margin-bottom: 29px !important;
  }

  ._s8 {
    margin-bottom: 40px;
  }

  .bl {
    border-left: 1px solid #979797;
  }

  h1 {
    text-transform: capitalize;
  }

  h2 {
    /*font-size: 24px;*/
    /*font-weight: 500;*/
    /*font-family: 'Rubik', 'sans-serif';*/
    /*letter-spacing: .04em !important;*/
    color: #2b2b2b;
  }

  h3 {
    margin-bottom: 26px;
    color: #5C5C5C;
    font-family: Inter;
    font-size: 18px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 20px;
  }

  hr {
    margin-bottom: 45px;
  }

  .product-wrapper {
    /*background-color: #292929;*/
    /*max-width: calc(100% - 280px);*/
    padding: 19px;
    padding-top: 0;
  }
  .product-splash, .product-choose-your-feel {
    width: 100%;
    height: 566px;
    margin-bottom: 120px;
  }
  .product-products {
    flex-wrap: wrap;
  }
  .product-product-image {
    width: 515px;
    min-width: 515px;
    height: 566px;
  }
  .top-bar-global {
    /*height: 68px;*/
  }
  .whole-page-box-global {
    max-width: 780px;
  }
  $image-upload-size: 182px;
  $image-upload-size-2: 130px;

  .image-upload {
    width: $image-upload-size;
    height: $image-upload-size;
    border-radius: 5px;
    /*padding: 12px;*/

    /*border: 1px dashed rgba(50, 50, 93, 0.1);*/
    border: 1px dashed #BFBFBF;
    font-size: 16px;
    background: white;
    display: flex;
    flex-direction: column;
    justify-content: center;

    &:hover {
      & + .dropzone-overlay {
        background-color: #fdfdfd;
        /*border: 1px dashed rgba(50, 50, 93, 0.12);*/
        border: 1px dashed #BFBFBF;
        
        a {
          background-color: #27C8B3;
          color: $color-white;
        }
      }
    }

    & > * {
      margin: 0 !important;
    }
  }
  .image-uploaded {
    width: $image-upload-size;
    height: $image-upload-size;
    border-radius: 5px;
    border: 1px solid rgba(50, 50, 93, 0.1);
    object-fit: cover;
  }
  .image-uploaded-under {
    margin-top: 6px;
    font-size: 12px;
  }
  .file-upload {
    width: 100%;
    /*max-width: 500px;*/
    height: 150px;
    border-radius: 5px;
    /*padding: 12px;*/
    border: 1px dashed rgba(50, 50, 93, 0.1);
    font-size: 16px;
    background: white;
    /*margin-right: 20px;*/
    display: flex;
    flex-direction: column;
    justify-content: center;

    &:hover {
      & + .dropzone-overlay {
        background-color: #fdfdfd;
        border: 1px dashed rgba(50, 50, 93, 0.12);
        
        a {
          background-color: #5469d4;
          color: $color-white;
        }
      }
    }
  }
  .product-delivery-file {
    & > div {
      border: 1px solid rgba(50, 50, 93, 0.1);
      border-radius: 5px;
      width: 100%;
      height: 150px;
    }
  }
  .dropzone-overlay {
    padding-left: 4px;
    padding-right: 4px;
    border-radius: 5px;
    position: absolute;
    left: 0;
    bottom: 0px;
    height: 100%;
    max-height: $image-upload-size;
    width: 100%;
    /*background-color: #aaa;*/
    pointer-events: none;
    display: flex;
    justify-content: center;
    align-items: center;
/*    background-color: #fbfbfb;
    border: 1px dashed rgba(50, 50, 93, 0.12);*/

    p, {
      font-size: 14px;
      margin-bottom: 2px;
      text-align: center;
    }

  }
  .product-basics {
    width: 425px;
    max-width: 425px;
    /*height: 200px;*/
    /*min-height: 200px;*/
  }
  @media (max-width: 980px) {
    .dropzone-wrapper {
      margin-left: 30px !important;
    }
    .image-upload {
      width: $image-upload-size-2;
      height: $image-upload-size-2;
      min-height: $image-upload-size-2;
    }
    .image-uploaded {
      width: $image-upload-size-2;
      height: $image-upload-size-2;
      min-height: $image-upload-size-2;
    }
    .dropzone-overlay {
      height: $image-upload-size-2;
      min-height: $image-upload-size-2;
    }
    .product-basics {
      /*height: $image-upload-size-2;*/
      /*min-height: $image-upload-size-2;*/
    }
  }
  textarea {
    border-radius: 5px;
    padding: 12px;
    border: 1px solid rgba(50, 50, 93, 0.1);
    height: 130px !important;
    min-height: 130px !important;
    font-size: 16px;
    width: 100% !important;
    background: white;
    margin-bottom: 6px;
  }
  .digital-download-details {
    height: 100%;
  }
  .product-detail {
    margin-bottom: 26px;
    /*max-width: 500px;*/

  p, input, textarea {
      // color: #000000;
      // font-family: Inter;
      // font-size: 14px;
      // letter-spacing: 0;
      // line-height: 24px;
    }
  }
  .product-detail-desctiption {
    margin-bottom: 16px;
  }
  .product-detail-outer {
    /*max-width: 500px;*/

    & > .product-detail {
      flex: 1;
      &:first-child {
        flex: 2;
        /*margin-right: 20px;*/
      }
    }
  }
  .product-basics {
    /*max-width: 500px;*/
    & > .product-detail {
      &:last-child {
        margin-bottom: 0px;
      }
    }
  }
  .product-detail-with-check {
    max-width: 540px; 
  }
  $placeholderColor: #898989;
  input, textarea, select {
    width: 100%;
    // max-width: 540px;
    // border-color: #BFBFBF !important;
    // background-color: #fff;
    // font-size: 14px;
    // padding: 12px 10px;
    // -webkit-box-shadow: none;
    // box-shadow: none;
    // font-family: 'Rubik', 'sans-serif';
    // color: rgb(43, 43, 43);
    // border-radius: 5px; 
    // width: 390px;
    max-width: 390px;
    border: none;
    height: 40px;
    border-radius: 2px;
    background-color: #F3F3F5;
    color: #5C5C5C;
    font-family: Inter;
    font-size: 12px;
    letter-spacing: 0;
    line-height: 18px;
    padding-left: 19px;
    /*padding-bottom: 8px;*/


    ::-webkit-input-placeholder { /* Edge */
      color: $placeholderColor;
    }

    :-ms-input-placeholder { /* Internet Explorer 10-11 */
      color: $placeholderColor;
    }

    ::placeholder {
      color: $placeholderColor;
    }
  }

  select {
    border-radius: 0;
    border: 1px solid black;
    background-color: transparent;
    -webkit-appearance: none;
    -moz-appearance: none;
    position: relative;
    /*padding-right: 20px;*/
    background-image: url('../../static/images/new-icon-chevron-down.svg');
    background-repeat: no-repeat;
    background-position: 95% 50%;
    &::after {
      content: ' ';
      width: 14px;
      height: 8px;
      background-position: center;
      background-size: contain;
      /*position: absolute;*/
      right: 10px;
      top: 2px;
    }
  }
  .sub-line {
    margin-bottom: 8px;
    color: #49494C;
    font-family: Inter;
    font-size: 12px;
    letter-spacing: 0;
    line-height: 13px;
  }
  .check-fulfillment {
    margin-right: 15px;

    input {
      width: 20px;
    }
  }
  .check-fulfillment-box {
    display: flex;
    flex-direction: column;
    height: 20px;
    margin: 0;
  }
  .mw2 {
    /*max-width: 500px;*/
  }
  .mw3 {
    /*max-width: 500px;*/
  }
  .just-save {
    background-color: transparent;
    box-shadow: none;
    color: #2b2b2b;
    font-family: Inter;
    font-weight: 400;
    font-size: 14px;
    margin-right: 24px;
  }
  .just-save-2 {
    font-size: 16px;
    border-radius: 5px;
    color: $color-primary;
    border: 1px solid $color-primary;
  }
  .button-b {
    border: 1px solid #5469d4;
    border-radius: 5px;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    color: #5469d4;
    padding: 2px 6px;
    height: 30px;

    &:hover {
      border: 1px solid transparent;
      background-color: #5469d4;
      color: $color-white;
    }
  }
  .image-dropzone-wrapper {
    /*margin-left: 20px;*/
  }
  .file-icon {
    opacity: 0.5;
    height: 35px;
    margin-bottom: 10px;
  }
  .file-text {
    font-size: 14px;
    margin-bottom: 10px;
  }
  .file-remove-text {
    font-size: 10px;
    text-decoration: underline;
  }
  .r0 {
    margin-right: 10px;
  }
  .r1 {
    margin-left: 10px;
  }
  .one-day {
    margin-top: 4px;
    margin-bottom: 4px;
  }
  .max-detail {
    /*max-width: 350px;*/
    select {
      max-width: 300px;
    }
  }
  .reference {
    margin-top: 4px;
    font-size: 12px;
    margin-bottom: 12px;
  }
  .previews {
    div {
      a {
        font-size: 14px;
        color: #444;
      }
    }
  }

  @media (max-width: 980px) {
    .digital-download-details {
      /*flex-direction: column-reverse;*/
      position: relative;
      .dropzone-wrapper-a {
        margin-left: 0;
        margin-bottom: 20px;
      }
    }
    .product-basics {
      width: 100%;
    }
    .product-detail {
      input, textarea {
        max-width: unset;
      }
    }
    .product-detail-with-check {
      width: 100%;
      max-width: unset;
    }
  }

  .delete-product {
    font-size: 12px;
    margin-top: 30px;
    margin-left: 40px;
    display: flex;
    justify-content: flex-end;
    padding-right: 40px;
    cursor: pointer;
  }

  .minh {
    height: 100%;
  }

  .o05 {
    opacity: 0.5;
    pointer-events: none;
  }
  .o00 {
    opacity: 0;
    pointer-events: none;
  }
  @media (max-width: 980px) {
    .o00 {
      display: none;
    }
  }
  .mty {
    margin-top: 20px;
  }
  .mtx {
    margin-top: 10px;
  }

  .selected-coffees {
    border-radius: 5px;
    margin-bottom: 30px;

    h4 {
      margin-bottom: 0;
    }

    .one-selected-coffee {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 85px;
      width: 88px;
      border-radius: 3px;
      padding: 10px;
      border: 1px solid black;
      /*background-color: #fefefe;*/
      position: relative;
      /*margin-left: 5px;*/
      margin-right: 25px;
      margin-top: 13px;

      p {
        color: #49494C;
        font-family: Inter;
        font-size: 12px;
        font-weight: bold;
        letter-spacing: 0;
        line-height: 16px;
        text-align: center;
/*        &:last-child {
          font-size: 12px;
          color: #555;
        }*/
      }

      .remove-selected-coffee {
        position: absolute;
        top: 5px;
        right: 5px;
        line-height: 12px;
        font-size: 15px;
        cursor: pointer;
      }
    }
    .add-new-coffee {
      border: 1px dashed #bbb;
      /*background-color: #fafafa;*/
      cursor: pointer;

      &:hover {
        background-color: #f7f7f7;
      }
      .span {
      }
    }

    .name {
      margin-bottom: 4px;
      /*font-size: 12px !important;*/
      /*color: #999 !important;*/
    }
    .none-selected {
      font-size: 12px;
    }
  }
  .add-coffee-popup-inner {
    margin-left: 30px;
    margin-right: 30px;
    & > * {
      width: 100%;
    }
  }
  .add-coffee-popup-inner {
    /*padding-right: 10px !important;*/
    max-height: 100vh;
    overflow-y: auto;
  }

  @media (max-width: 1020px) {
    .add-coffee-popup-inner {
      height: 100vh;
      width: 100% !important;
      max-width: unset !important;
      border-radius: 0;
      margin: 0;
    }
  }
  @media (max-width: 440px) {
    .add-coffee-popup-inner {
      margin-left: 15px;
      margin-right: 15px;
    }
  }

  @media (max-width: 800px) {
    .top-bar-global {
      height: unset;
    }
    .breadcrumb {
      font-size: 0.8em;
    }
  }

  @media (max-width: 440px) {
    .product-wrapper {
      padding-left: 6px;
      padding-right: 6px;
    }
  }

  @media (max-width: 320px) {
    .product-wrapper {
      padding-left: 0px;
      padding-right: 0px;
    }
    .whole-page-box-global {
      border-radius: 0;
    }
  }

$square-height: 25px;

.color-options {
  height: $square-height * 2;
  width: $square-height * 2;
  /*border: 1px solid grey;*/
}
.one-color-option {
}
.color-row {
}
.one-color {
  height: $square-height;
  width: $square-height;
}

.tag {
  color: #000000;
  font-family: Inter;
  font-size: 12px;
  letter-spacing: 0;
  line-height: 24px;
  margin-bottom: 13px;
  /*margin-left: 10px;*/
}


@media (max-width: 1020px) {
  .add-coffee-popup {
    width: 100%;
  }
  .add-coffee-popup-inner {
    height: 100vh;
    width: 100% !important;
    max-width: unset !important;
    border-radius: 0;
    margin: 0;
  }
}

.x-close {
  width: 22px !important;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
}

.image-dropzone-wrapper {
  margin-left: 27px;
}

.share-url {
  margin-left: 185px;
  position: absolute;
  left: 100%;
  margin-bottom: 10px;
  width: 100%;
  max-width: 660px;
  min-width: 660px;
  transform: translateY(-25%);
  & > div {
    height: 42px;
    border-radius: 29px;
    background-color: $color-primary;
    border: 1px solid $color-primary;
    display: flex;
    align-items: center;
    width: 100%;
    padding-left: 30px;
    padding-right: 30px;
    /*padding: 20px 30px;*/

    p, a {
      color: white;
    }

    .header, .link {
      color: #FFFFFF !important;
      font-family: Inter;
      font-size: 14px;
      font-weight: bold;
      letter-spacing: 0;
      line-height: 16px;
    }

    .header {
      width: 140px;
      min-width: 140px;
      /*margin-bottom: 10px;*/
      /*font-weight: 500;*/
      /*font-size: 12px;*/
      /*font-family: 'Inter'*/
    }
    .link {
      text-align: center;
      
      /*text-align: center;*/
      /*font-size: 16px;*/
      /*font-weight: 600;*/
      /*margin-bottom: 10px;*/
      /*word-break: break-all;*/

      &:hover {
        text-decoration: none;
      }
    }
    .link-bigger {
      /*font-size: 18px;*/
    }
    @media (max-width: 420px) {
      /*.link {
        font-size: 14px;
      }*/
    }
    .copy {
      text-decoration: none;
      font-size: 13px;
      font-weight: 400;

      &:hover {
        text-decoration: underline;
      }
    }
  }
}

.share-url2 {
  position: relative;
  left: unset;
  margin-left: 0;
  margin-top: -20px;
  margin-bottom: 15px;
}

.copied {
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.07s;
  position: absolute;
  bottom: 7px;
  right: 120px;
  font-size: 12px;
  background-color: white;
  border-radius: 5px;
  padding: 6px 8px;
  color: black !important;
}

.show-copied {
  opacity: 1;
}

button {
  border-radius: 5px;
}

.product-detail button:last-child {
  margin-left: 10px;
}

.save-session-error, .validation-error {
  color: #ff0c0c !important;
}

.whole-page-box-global-2 {
  align-items: flex-start;
}

input[type="checkbox"] {
  border-radius: 50%;
}

.product-detail-list {
  div {
      h4 {
          margin-bottom: 3px !important;
      }
      .sub-line {
        margin-bottom: 6px;
      }
  }
  .product-detail {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
  }
}

.check-fulfillment {

}

.check-fulfillment {
  position: relative;
}

.check-fulfillment label {
  border-radius: 50%;
  cursor: pointer;
  left: 0;
  position: absolute;
  top: 0;
  height: 18px;
  width: 18px;
  border: 1px solid #5C5C5C;
  background-color: #F3F3F5;
}

.check-fulfillment label:after {
  content: " ";
  height: 10px;
  width: 10px;
  background-color: #27C8B3;
  left: 3px;
  border-radius: 50%;
  opacity: 0;
  position: absolute;
  top: 3px;
  /*transform: rotate(-45deg);*/
}

.check-fulfillment input[type="checkbox"] {
  visibility: hidden;
}

.check-fulfillment input[type="checkbox"]:checked + label {
  /*background-color: #66bb6a;*/
  /*border-color: #66bb6a;*/
}

.check-fulfillment input[type="checkbox"]:checked + label:after {
  opacity: 1;
}

.share-url-v2 {
  position: relative;
  display: none;
}
@media (max-width: 1330px) { 
  .share-url-v1 {
    display: none;
  }
  .share-url-v2 {
    display: flex;
    left: unset;
    margin-left: 0;
  }
}

.share-url-v3  {
  .copied {
    right: 20px;
  }
}
@media (max-width: 1085px) {
  .share-url {
    min-width: unset;
    & > div {
      padding-left: 15px;
      padding-right: 15px;
      height: unset;
      padding-top: 10px;
      padding-bottom: 10px;
      a {
        margin-top: 5px;
        margin-bottom: 5px;
      }
      flex-direction: column;
    }
  }
  .share-url-v2 {
    margin-top: 15px;
    margin-bottom: 0;
  }

  .share-url2 {
    margin-top: 10px;
  }
  .copied {
    left: 50%;
    bottom: 33px;
    width: 55px;
    transform: translateX(-50%);
  }
  .share-url-v3  {
    .copied {
      bottom: 8px;
    }
  }
}

@media (max-width: 1300px) {
  ._s8 {
    flex-direction: column;
  }
  .mtx {
    display: none;
  }
  .share-url {
  }
  ._s6 {
    .bl {
      border: none;
      padding-left: 0 !important;
    }
  }
}

@media (max-width: 735px) {
  ._x {
    flex-direction: column-reverse;
    .product-basics {
      /*margin-bottom: 30px;*/
      ._s3 {
        margin-bottom: 25px !important;
      }
    }
    .image-dropzone-wrapper {
      margin-left: 0 !important;
      margin-bottom: 35px;
    }
  }
}

.more-less-options {
  margin-right: 6px;
}

.cancel-add {
  margin-left: 57px;
}
.custom-link-coffee-name {
  margin-right: 20px;
  color: #000;
  font-family: Inter;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 16px;
}
.custom-h4 {
  margin-top: 30px;
  margin-bottom: 20px;
  color: #5C5C5C;
  font-family: Inter;
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 20px;
}
.one-coffee-custom {
  margin-bottom: 15px;
  &:last-child {
    margin-bottom: 0;
  }
}
.your-code-customized {
  p:first-child {
      font-size: 12px;
      margin-bottom: 10px;
  }
  p:last-child {
    font-size: 24px;
    color: $color-primary;
    margin-bottom: 30px;
    text-align: center;
    /*font-weight: 600;*/
  }
}
.dis {
  margin-top: 20px !important;
  display: flex !important;
  position: relative;
  width: unset !important;
  left: unset;
  top: unset;
  transform: unset;
  margin: 0;
  min-width: unset;
  width: 100% !important;
}

.share-url-v3 {
  max-height: unset;

  & > * {
    padding-top: 10px;
    padding-bottom: 10px;
    /*height: 200px;*/
    min-height: 42px;
    height: unset !important;
  }
}

.embed-input {
  width: 100% !important;
  max-width: 100px;
}

.custom-embed-label {
  font-size: 12px;
}

.disable-custom {
  opacity: 0.5;
  pointer-events: none;
}

.special-link {
  margin-bottom: 15px;
  font-size: 14px;

  p {
    margin-right: 6px;
  }

  a {
    color: $color-primary;
  }
}

.line-x {
  width: 100%;
  height: 1px;
  background-color: #ddd;
  border: none;
  margin-bottom: 20px;
}


</style>



// WEBPACK FOOTER //
// src/pages/AddTemplate.vue